import { AfterViewInit, Component, ViewEncapsulation } from '@angular/core';
import { GroupService } from '../groups/groups.service';
import { FormValidator } from '../form.validator';
import { TransportService } from '../transport/transport.service';
import { EditStudentPopupComponent } from '../edit-student-popup/edit-student-popup.component';

/**
 * Edit Student Info popup — new design, same behaviour.
 *
 * Extends the existing EditStudentPopupComponent, so every field, validation,
 * upload, transport/term rule and API call is inherited unchanged; only the
 * template (modal shell) and styles (same look as the New Admission popup) are
 * new. The template keeps all element ids, template refs and handlers the
 * inherited code relies on. The constructor is inherited too; component-level
 * providers are not, so they are repeated here.
 */
@Component({
  selector: 'app-edit-student-popup-v2',
  templateUrl: './edit-student-popup-v2.component.html',
  styleUrls: ['./edit-student-popup-v2.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [GroupService, FormValidator, TransportService],
})
export class EditStudentPopupV2Component extends EditStudentPopupComponent implements AfterViewInit {
  // Focus handling inside the long form can leave the body scrolled past its
  // first rows; always open at the top.
  ngAfterViewInit(): void {
    setTimeout(() => {
      const body = document.querySelector('.ev2 .ev2-body');
      if (body) {
        body.scrollTop = 0;
      }
    });
  }
}
